import * as React from "react";
import { useMemo } from "react";
import { EditorState, Transaction } from "prosemirror-state";
import { ButtonDefinition } from "./ButtonDefinitions";
import ToolButton from "./ToolButton";

export interface Props {
	definition: ButtonDefinition;
	staleEditorState: EditorState;
	getEditorState(): EditorState;
	dispatch(transaction: Transaction): void;
	readonly?: boolean;
}

export default function CommandButton(props: Props) {
	const enabled = useMemo(
		() => props.definition.command(props.staleEditorState),
		[props.definition.command, props.staleEditorState]
	);
	const active = useMemo(
		() => !!props.definition.active?.(props.staleEditorState),
		[props.definition.active, props.staleEditorState]
	);

	function handleClick() {
		props.definition.command(props.getEditorState(), props.dispatch);
	}
	return (
		<ToolButton
			active={active}
			onClick={handleClick}
			disabled={props.readonly || !enabled}
			title={props.definition.title}
		>
			{props.definition.icon}
		</ToolButton>
	);
}
